/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExtrasN } from './extrasN';
import type { ExtrasNStudents } from './extrasNStudents';
import type { ExtrasTooFew } from './extrasTooFew';
import type { ExtrasWeekly } from './extrasWeekly';
import type { ExtrasP20 } from './extrasP20';
import type { ExtrasP80 } from './extrasP80';
import type { ExtrasParts } from './extrasParts';
import type { ExtrasAt } from './extrasAt';
import type { ExtrasNRevising } from './extrasNRevising';

export interface Extras {
  n: ExtrasN;
  nStudents: ExtrasNStudents;
  tooFew: ExtrasTooFew;
  weekly: ExtrasWeekly;
  p20: ExtrasP20;
  p80: ExtrasP80;
  parts: ExtrasParts;
  at: ExtrasAt;
  /** score_by_attempt only: of the n sessions, how many submitted this attempt */
  nRevising: ExtrasNRevising;
}
